import { BusinessUnitShort, Dimension } from 'src/@enums'
import { BASE_DIMENSIONS, EUDORA_DIMENSIONS } from 'src/constants'

/**
 * [TARGET] Retorna uma dimensão baseado no business unit.
 *
 * @param dimension Dimension que deseja retornar
 * @param businessUnit Business unit.
 *
 * @example
 * import { getDimensionByUnit } from 'src/utils'
 *
 * //dimension20 se o business unit for EUD, senão, dimension22, para as outros business units.
 * getDimensionByUnit(Dimension.CF_ID, 'EUD')
 *
 * @returns `string` -> Dimensão respectiva da marca requisitada.
 */

export const getDimensionByUnit = (
  dimension: Dimension,
  businessUnit: `${BusinessUnitShort}` = BusinessUnitShort.BOT,
) =>
  businessUnit === BusinessUnitShort.EUD ? EUDORA_DIMENSIONS[dimension] : BASE_DIMENSIONS[dimension]
